import { render } from "./Financials.vue?vue&type=template&id=5cda3090"
import script from "./Financials.vue?vue&type=script&lang=js"
export * from "./Financials.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akosipau/Dropbox/Sites/onboarding/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__